<div class="form-field-help font-size-xsm mt-1 mb-0">
  <span>{{('component.sms_sign_up_information.start' | translate: {merchantName: (storeConfig.storeConfig$ | async)?.corporateName ?? (storeConfig.storeConfig$ | async)?.name})}} </span>
  <ng-container [ngTemplateOutlet]="url" [ngTemplateOutletContext]="{url: (storeConfig.storeConfig$ | async)?.termsAndConditionsUrl, text: ('component.sms_sign_up_information.terms_and_conditions' | translate)}"></ng-container>
  <span translate> component.sms_sign_up_information.and </span>
  <ng-container [ngTemplateOutlet]="url" [ngTemplateOutletContext]="{url: (storeConfig.storeConfig$ | async)?.privacyPolicyUrl, text: ('component.sms_sign_up_information.privacy_policy' | translate)}"></ng-container>
  <span *ngIf="(storeConfig.storeConfig$ | async)?.privacyPolicyUrl || (storeConfig.storeConfig$ | async)?.termsAndConditionsUrl">.</span>
</div>

<ng-template #url let-url="url" let-text="text">
  <span *ngIf="!!url; else simple_text">
    <a [href]="url" target="_blank" [attr.aria-label]="text + ' ' + ('route.new_tab.opens_new_tab' | translate)" class="btn-link btn-undecorated font-primary dotted p-0 fw-600">{{text}}</a>
  </span>

  <ng-template #simple_text>
    <span>{{text}}</span>
  </ng-template>
</ng-template>